import React from 'react';
import type OverviewSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-overview/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyOverviewSettings = lazyForPaint<typeof OverviewSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-overview", jiraSpaEntry: "async-project-settings-overview" */ '@atlassian/jira-spa-apps-project-settings-service-desk-overview'
		),
	),
);

export const AsyncOverviewSetting = () => (
	<LazyPage
		Page={LazyOverviewSettings}
		pageId="project-settings-overview"
		shouldShowSpinner={false}
	/>
);
